export var account = function account(centralApi) {
  return {
    get: function get(ani, params) {
      if (params === void 0) {
        params = null;
      }
      return centralApi.get("/account/".concat(ani), {
        params: params
      });
    }
  };
};